/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimFolder } from './ClaimFolder';
import {
    ClaimFolderFromJSON,
    ClaimFolderFromJSONTyped,
    ClaimFolderToJSON,
    ClaimFolderToJSONTyped,
} from './ClaimFolder';

/**
 * List of claim folders
 * @export
 * @interface ClaimFolderListResponse
 */
export interface ClaimFolderListResponse {
    /**
     * 
     * @type {Array<ClaimFolder>}
     * @memberof ClaimFolderListResponse
     */
    folders: Array<ClaimFolder>;
}

/**
 * Check if a given object implements the ClaimFolderListResponse interface.
 */
export function instanceOfClaimFolderListResponse(value: object): value is ClaimFolderListResponse {
    if (!('folders' in value) || value['folders'] === undefined) return false;
    return true;
}

export function ClaimFolderListResponseFromJSON(json: any): ClaimFolderListResponse {
    return ClaimFolderListResponseFromJSONTyped(json, false);
}

export function ClaimFolderListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFolderListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'folders': ((json['folders'] as Array<any>).map(ClaimFolderFromJSON)),
    };
}

export function ClaimFolderListResponseToJSON(json: any): ClaimFolderListResponse {
    return ClaimFolderListResponseToJSONTyped(json, false);
}

export function ClaimFolderListResponseToJSONTyped(value?: ClaimFolderListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'folders': ((value['folders'] as Array<any>).map(ClaimFolderToJSON)),
    };
}

